<template>
  <div class="audio-page">
    <h2>{{resourceTitle}}</h2>
		<audio :src="resourceUrl" controlsList="nodownload" controls="controls">
		</audio>
  </div>
</template>

<script>
export default {
	name: 'audioPage',
	data () {
		return {
			resourceTitle: '',
			resourceUrl: '',
			audioResourceId: this.$route.params.audioResourceId,
		}
	},
	mounted () {
		let vm = this
		document.head.querySelector('meta[name=viewport]').content = 'width=device-width, initial-scale=1, maximum-scale=1'
		vm.$http.get(`/v1/audio/${vm.audioResourceId}`)
			.then(response => {
				vm.resourceTitle = response.data.data.resourceTitle
				vm.resourceUrl = response.data.data.resourceUrl
			}).catch(() => {
				vm.$route.push('/user/login')
				vm.$message.warning('获取音频链接失败')
			})
  }
}
</script>
<style lang="less" scoped>
.audio-page {
	text-align: center;
	margin: 25px 10px;
}
</style>

